module.exports = __webpack_public_path__ + "0aaa9961553e6063e4f9e038dae666f2.svg";